import { useEffect } from 'react';
import { webLogger } from '@/common/log';
import yoda from '@kibt/bridge';
import { versionCompare } from '@kibt/web-utils/version';
import { isAndroid, appVersion } from './device-info';
import { radar } from '@/common/log';
import { isIOS } from '@kibt/krn-utils';
import { useQuery } from '@/hooks/useQuery';

export function useCheckMediaSource(radarEventName: string) {
    const extParams = useQuery('extParams') as string;
    useEffect(() => {
        try {
            const media_source = JSON.parse(extParams)?.cT;
            radar.event({ name: radarEventName, params: { media_source, extParams } });
        } catch (e) {
            radar.event({ name: radarEventName, params: { media_source: '', extParams } });
        }
    }, []);
}
const bindTypeMap = {
    pv(value) {
        webLogger.sendLog(value);
    },
    show(value) {
        webLogger.sendLog(value);
    },
    click(el: HTMLElement, value) {
        // el.onclick = function () {
        //     clickLog(el, value);
        // };
    },
};
export const useLogAttribute = (logConfig: any) => {
    useEffect(() => {
        if (logConfig && logConfig.type !== 'custom' && bindTypeMap[logConfig.type]) {
            const type = logConfig.type;
            setTimeout(() => {
                bindTypeMap[type](logConfig);
            }, 50);
        }
    }, []);
    return null;
};

let forbidWebDrag;

/**
 * 安卓 版本大于 9.0.20 时候 才调用这个桥 ios不需要
 */
export function onForbidWebDrag(forbid: boolean) {
    // 如果设置过桥了，不要连续无休止调用
    if (forbidWebDrag === forbid) {
        return;
    } else {
        // 没有调用过记录调用
        forbidWebDrag = forbid;
    }
    // |-1 |version1<version2|
    // |1  |version1>version2|
    // 只有版本大于 9.0.20 时候 才调用这个桥
    console.log('调用forbidWebDrag', forbid);
    if (isAndroid && versionCompare(appVersion, '9.0.20') === 1) {
        console.log('调用forbidWebDrag', forbid);
        try {
            yoda.component.forbidWebDrag({ isForbid: forbid });
        } catch (error) {
            console.log('调用forbidWebDrag 失败');
        }
    }
    // IOS 版本大于 9.9.40 时候 才调用这个桥
    if (isIOS && versionCompare(appVersion, '9.9.40') > -1) {
        (yoda.kwaiInvoke ?? yoda.invoke)?.('component.forbidWebDrag', { isForbid: forbid }).catch((err) => {
            console.log('调用 component.forbidWebDrag 失败');
        });
    }
}
